import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgManagedPostgreSql = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-managed-postgre-sql';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M9.5 3.041c-1.132.092-2.216.343-2.922.676-1.219.575-1.734 1.288-2.015 2.789-.37 1.971-.179 4.607.456 6.314.59 1.587 1.553 2.404 2.741 2.326a2.6 2.6 0 0 0 1.089-.288c1.127-.566 1.997-1.92 2.507-3.904.154-.597.319-1.532.278-1.573-.022-.023-1.447-.179-1.466-.161a4 4 0 0 0-.072.406c-.278 1.865-1.054 3.447-1.901 3.877-.299.152-.677.178-.903.063-.456-.232-.888-1.08-1.148-2.249-.376-1.69-.331-4.186.097-5.337.067-.18.15-.301.337-.485.486-.481 1.296-.758 2.691-.92.669-.078 2.173-.055 2.891.044 2.846.394 4.935 1.459 5.657 2.885.187.37.264.675.291 1.161.09 1.595-.712 3.55-2.138 5.215-.295.344-1.351 1.362-1.854 1.788-.666.563-1.024 1.132-1.24 1.968-.343 1.336.476 2.788 1.823 3.232.282.093.384.106.841.104.582-.001.956-.087 1.528-.352.332-.153.852-.486.852-.544 0-.057-.836-1.156-.879-1.156a1 1 0 0 0-.216.121c-.594.401-1.351.552-1.785.356a1.34 1.34 0 0 1-.593-.577c-.094-.176-.107-.246-.107-.58 0-.347.011-.403.128-.642.195-.398.387-.605 1.137-1.227.056-.047.128.012.585.476l.522.53.533-.525.533-.525-.512-.526-.513-.525.094-.115c.051-.063.22-.264.375-.448.989-1.167 1.709-2.477 2.099-3.816a6.7 6.7 0 0 0 .29-1.997c.002-.854-.111-1.381-.439-2.052-1.085-2.215-4.455-3.741-8.446-3.826a16 16 0 0 0-1.226.019m4.54 5.756c-.66.202-1.064.92-.868 1.543.079.253.167.389.377.585.258.242.523.331.909.306 1.08-.069 1.546-1.367.764-2.127-.297-.288-.808-.421-1.182-.307"
    })
  }));
});
export default SvgManagedPostgreSql;